<template>
  <div class="news">
    <div class="news-item" @click="toNewsDetail(item.id)" v-for="(item,i) in newsList">
      <img :src="application.imageHost+item.logoPath">
      <div class="news-item-content">
        <div class="news-title">{{item.name}}</div>
        <div class="new-time">{{item.author}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.createTime}}</div>
        <div class="news-content">{{item.des}}</div>
      </div>

    </div>
<!--    <div class="news-item"></div>-->
<!--    <div class="news-item"></div>-->
  </div>
</template>
<style src="./news.css" scoped></style>

<script>
    import mixins from '../../common/mixin';
    import application from '../../common/application'

    export default {
        name: "news",
        data:()=>({
            application:application,

            newsList:[],

        }),
        mixins:[mixins],
        props:{
            pageSize:{
                type:Number,
                required: true
            },
            pageIndex:{
                type:Number,
                required: true
            }
        },
        created(){


        },
      mounted() {
          this.handleNewsList();
      },
        methods:{
            //跳转到新闻详情
            toNewsDetail(id){
              this.$router.push({
                  path:'/newsDetail/'+id
              })
            },
            // 获取新闻列表
            handleNewsList(){
                this.request({
                    url: '/web/news/list',
                    data:{
                        "pageIndex": this.pageIndex,
                        "pageSize": this.pageSize,
                        // "type": "string",
                        // "userId": 0

                    },
                    success: (response) => {

                        this.newsList=response.data.records;
                        for(var i=0;i<this.newsList.length;i++){
                            this.newsList[i].createTime=this.formatDate(new Date(parseFloat(this.newsList[i].createTime)),'yyyy-MM-dd hh:mm')

                        }

                        console.log('newsList',this.newsList)

                    },
                    error: (response) => {
                        this.$Message.error(response.message);
                    },
                    complete: () => {
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/news/news.vue